import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3bcd9d9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "tyre_range_tabs p-0",
  id: "tyreRange"
}
const _hoisted_2 = {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}
const _hoisted_3 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_4 = ["id", "data-bs-target", "aria-controls", "onClick"]
const _hoisted_5 = { class: "thumb_wrap" }
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_9 = ["id", "aria-labelledby"]
const _hoisted_10 = ["id"]
const _hoisted_11 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_12 = ["id", "data-bs-target", "aria-controls"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = ["id"]
const _hoisted_15 = ["id", "aria-labelledby"]
const _hoisted_16 = { class: "wrapper top_content" }
const _hoisted_17 = { class: "container" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-6 col-lg-3 d-flex align-items-center" }
const _hoisted_20 = { class: "slider" }
const _hoisted_21 = ["id"]
const _hoisted_22 = { class: "carousel-inner" }
const _hoisted_23 = ["data-fancybox", "href"]
const _hoisted_24 = ["src", "alt"]
const _hoisted_25 = { class: "carousel-indicators" }
const _hoisted_26 = ["data-bs-target", "data-bs-slide-to", "aria-label"]
const _hoisted_27 = { class: "col-md-6 col-lg-3 d-flex align-items-center order-lg-3" }
const _hoisted_28 = { class: "video" }
const _hoisted_29 = ["src"]
const _hoisted_30 = { class: "col-md-12 col-lg-6 d-flex align-items-center" }
const _hoisted_31 = { class: "text_wrapper" }
const _hoisted_32 = { class: "text" }
const _hoisted_33 = { class: "sub_title" }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = {
  key: 0,
  class: "list_square"
}
const _hoisted_36 = ["innerHTML"]
const _hoisted_37 = { class: "btn_group d-none d-lg-flex" }
const _hoisted_38 = ["href"]
const _hoisted_39 = { class: "product_portfolio" }
const _hoisted_40 = { class: "container" }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "title" }, "PRODUCT PORTFOLIO", -1))
const _hoisted_43 = { class: "wrapper" }
const _hoisted_44 = { class: "list_square" }
const _hoisted_45 = { class: "partner_list" }
const _hoisted_46 = ["src"]
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "advanced_features overlay_bg" }
const _hoisted_49 = { class: "container" }
const _hoisted_50 = { class: "title white text-center" }
const _hoisted_51 = ["innerHTML"]
const _hoisted_52 = { class: "list" }
const _hoisted_53 = { class: "box white_bg" }
const _hoisted_54 = { class: "top" }
const _hoisted_55 = { class: "img" }
const _hoisted_56 = ["src"]
const _hoisted_57 = { class: "text" }
const _hoisted_58 = { class: "title border_none" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "list_title" }, "PRODUCT FEATURE", -1))
const _hoisted_60 = {
  key: 0,
  class: "list_square"
}
const _hoisted_61 = {
  key: 1,
  class: "list_title"
}
const _hoisted_62 = {
  key: 2,
  class: "list_square"
}
const _hoisted_63 = {
  key: 3,
  class: "list_title"
}
const _hoisted_64 = {
  key: 4,
  class: "list_square"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tyreList, (row, index) => {
        return (_openBlock(), _createElementBlock("li", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["nav-link", index== 0 ?'active' :'']),
            id: row.name+'-tab',
            "data-bs-toggle": "tab",
            "data-bs-target": '#'+row.name,
            type: "button",
            role: "tab",
            "aria-controls": row.name,
            "aria-selected": "true",
            onClick: $event => (_ctx.openInfo(row.name))
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: _ctx.getImgUrl(row.image),
                alt: row.name
              }, null, 8, _hoisted_6),
              _createElementVNode("img", {
                src: _ctx.getImgUrl(row.tyre_image),
                alt: "tyre",
                class: "img-fluid tyre"
              }, null, 8, _hoisted_7),
              _createElementVNode("span", null, _toDisplayString(row.name), 1)
            ])
          ], 10, _hoisted_4)
        ]))
      }), 256))
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tyreList, (row, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["tab-pane fade", index== 0 ?'active show' :'']),
          id: row.name,
          role: "tabpanel",
          "aria-labelledby": row.name+'-tab'
        }, [
          (row.typeCount > 0)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 0,
                class: "nav nav-tabs",
                id: 'myTabInner'+index,
                role: "tablist"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.tyreType, (type, n) => {
                  return (_openBlock(), _createElementBlock("li", _hoisted_11, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["nav-link", n == 0 ?'active' :'']),
                      id: type.name+'-tab',
                      "data-bs-toggle": "tab",
                      "data-bs-target": '#'+type.name,
                      type: "button",
                      role: "tab",
                      "aria-controls": type.name,
                      "aria-selected": "true"
                    }, [
                      _createElementVNode("span", {
                        innerHTML: type.title
                      }, null, 8, _hoisted_13)
                    ], 10, _hoisted_12)
                  ]))
                }), 256))
              ], 8, _hoisted_10))
            : _createCommentVNode("", true),
          (row.typeCount > 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "tab-content ss",
                id: 'myTabInnerContent'+index
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.tyreType, (type, n) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: _normalizeClass(["tab-pane fade", n == 0 ?'active show' :'']),
                    id: type.name,
                    role: "tabpanel",
                    "aria-labelledby": type.name
                  }, [
                    _createElementVNode("section", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", {
                                id: type.name+n,
                                class: "carousel slide",
                                "data-bs-ride": "carousel"
                              }, [
                                _createElementVNode("div", _hoisted_22, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.slider, (slide, i) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: _normalizeClass(["carousel-item", i == 0 ?'active' :'']),
                                      "data-interval": "1000"
                                    }, [
                                      _createElementVNode("a", {
                                        "data-fancybox": _ctx.getImgUrl(slide.image),
                                        href: _ctx.getImgUrl(slide.image)
                                      }, [
                                        _createElementVNode("img", {
                                          src: _ctx.getImgUrl(slide.image),
                                          class: "d-block w-100",
                                          alt: slide.alt
                                        }, null, 8, _hoisted_24)
                                      ], 8, _hoisted_23)
                                    ], 2))
                                  }), 256))
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.slider, (slide, i) => {
                                    return (_openBlock(), _createElementBlock("button", {
                                      type: "button",
                                      "data-bs-target": '#'+type.name+n,
                                      "data-bs-slide-to": i,
                                      class: _normalizeClass(i == 0 ?'active' :''),
                                      "aria-current": "true",
                                      "aria-label": 'Slide'+i
                                    }, null, 10, _hoisted_26))
                                  }), 256))
                                ])
                              ], 8, _hoisted_21)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", _hoisted_28, [
                              (type.video)
                                ? (_openBlock(), _createElementBlock("iframe", {
                                    key: 0,
                                    src: type.video,
                                    allowfullscreen: ""
                                  }, null, 8, _hoisted_29))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("p", _hoisted_33, _toDisplayString(type.subTitle), 1),
                                _createElementVNode("h2", {
                                  class: "title",
                                  innerHTML: type.title
                                }, null, 8, _hoisted_34),
                                _createElementVNode("p", null, _toDisplayString(type.description), 1),
                                (type.features)
                                  ? (_openBlock(), _createElementBlock("ul", _hoisted_35, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.features, (fs) => {
                                        return (_openBlock(), _createElementBlock("li", { innerHTML: fs }, null, 8, _hoisted_36))
                                      }), 256))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("ul", _hoisted_37, [
                                _createElementVNode("li", null, [
                                  _createElementVNode("a", {
                                    href: type.brochure,
                                    download: "falken-brochure.pdf",
                                    target: "_blank",
                                    class: "btn green_btn"
                                  }, "DOWNLOAD PRODUCT BROCHURE", 8, _hoisted_38)
                                ])
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("section", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("p", {
                          class: "sub_title",
                          innerHTML: type.title
                        }, null, 8, _hoisted_41),
                        _hoisted_42,
                        _createElementVNode("div", _hoisted_43, [
                          _createElementVNode("ul", _hoisted_44, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.product_portfolo, (pp) => {
                              return (_openBlock(), _createElementBlock("li", null, _toDisplayString(pp), 1))
                            }), 256))
                          ]),
                          _createElementVNode("ul", _hoisted_45, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.partner, (part, num) => {
                              return (_openBlock(), _createElementBlock("li", null, [
                                _createElementVNode("img", {
                                  src: _ctx.getImgUrl(part.image),
                                  alt: "partner"
                                }, null, 8, _hoisted_46)
                              ]))
                            }), 256))
                          ]),
                          _createElementVNode("img", {
                            class: "product_portfolo_image",
                            src: _ctx.getImgUrl(type.product_portfolo_image),
                            alt: "partner"
                          }, null, 8, _hoisted_47)
                        ])
                      ])
                    ]),
                    _createElementVNode("section", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("h2", _hoisted_50, [
                          _createTextVNode(" ADVANCED FEATURES "),
                          _createElementVNode("span", {
                            innerHTML: type.title
                          }, null, 8, _hoisted_51)
                        ]),
                        _createElementVNode("ul", _hoisted_52, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.advanced_features, (feature, ind) => {
                            return (_openBlock(), _createElementBlock("li", null, [
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("div", _hoisted_55, [
                                    _createElementVNode("img", {
                                      src: _ctx.getImgUrl(feature.image),
                                      alt: "feature.title"
                                    }, null, 8, _hoisted_56)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_57, [
                                  _createElementVNode("h4", _hoisted_58, _toDisplayString(feature.title), 1),
                                  _hoisted_59,
                                  (feature.product_features.length > 0)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_60, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feature.product_features, (pf) => {
                                          return (_openBlock(), _createElementBlock("li", null, _toDisplayString(pf), 1))
                                        }), 256))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (feature.function.length > 0)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_61, " FUNCTION "))
                                    : _createCommentVNode("", true),
                                  (feature.function.length > 0)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_62, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feature.function, (ff) => {
                                          return (_openBlock(), _createElementBlock("li", null, _toDisplayString(ff), 1))
                                        }), 256))
                                      ]))
                                    : _createCommentVNode("", true),
                                  (feature.benefit.length > 0)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_63, " BENEFIT "))
                                    : _createCommentVNode("", true),
                                  (feature.benefit.length > 0)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_64, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feature.benefit, (fb) => {
                                          return (_openBlock(), _createElementBlock("li", null, _toDisplayString(fb), 1))
                                        }), 256))
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ])
                            ]))
                          }), 256))
                        ])
                      ])
                    ])
                  ], 10, _hoisted_15))
                }), 256))
              ], 8, _hoisted_14))
            : _createCommentVNode("", true)
        ], 10, _hoisted_9))
      }), 256))
    ])
  ]))
}